import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useMeContext } from '~/modules/me';
import { USER_DAL } from '~/modules/common/enums';

export const RESOURCE_USER_ROLE_SCHEDULE_AS_OF_DATE_QUERY = gql`
  query GetResourceUserRoleScheduleAsOfDate(
    $filter: GetResourceUsersFilter
    $asOfDate: Date2
  ) {
    resourceUsers2(filter: $filter) {
      id
      uri
      displayText
      roleSchedulesAsOfDate(asOfDate: $asOfDate) {
        effectiveRoleSchedule {
          effectiveDate
          projectRoles {
            projectRole {
              uri
              name
            }
            isPrimary
          }
        }
      }
    }
  }
`;

export const useResourceUserRoleScheduleAsOfDate = ({
  userIds,
  asOfDate,
  skip
}) => {
  const {
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  const effectiveDataAccessLevelUris = isPsaRmpEnhancedProjectManagerPersonaEnabled
    ? [USER_DAL.PROJECT_MANAGER, USER_DAL.RESOURCE_MANAGER]
    : undefined;

  const queryVariables = {
    filter: { userIds, effectiveDataAccessLevelUris },
    asOfDate
  };

  const { data } = useQuery(RESOURCE_USER_ROLE_SCHEDULE_AS_OF_DATE_QUERY, {
    variables: queryVariables,
    skip
  });

  return {
    roleSchedulesAsOfDateByUserUri: (data?.resourceUsers2 || []).reduce(
      (acc, user) => {
        acc[user.uri] = user.roleSchedulesAsOfDate;

        return acc;
      },
      {}
    )
  };
};

export default useResourceUserRoleScheduleAsOfDate;
